(() => {
    angular
        .module('coachingModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('coachingCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache) => {
            $scope.coachingSilentMode = false;
            $scope.silent = {};
            $scope.entryQueue = [];
            $scope.entryInProgress = false;
            $scope.coachingFull = false;
            $scope.emptyData = false;

            $rootScope.$watch('translate', (func) => {
                if(func) {
                    $scope.translate = func;
                }
            });

            $scope.init = (() => {
                $scope.loadingCoach = true;
                canvasService.getCoach($rootScope.currentAPId)
                    .success((res) => {
                        $scope.loadingCoach = false;

                        if (res.Parameters) {
                            $scope.coachData = {
                                entries: [],
                                enabled: true
                            };

                            let entries = JSON.parse(res.Parameters) || [];
                            $scope.coachData.entries = entries.map((entry) => {
                                if(entry.category) {
                                    entry.category = $scope.translate(`canvas.coach.${entry.key}.category`);
                                    entry.subCategory = $scope.translate(`canvas.coach.${entry.key}.subcategory`);
                                    entry.description = $scope.translate(`canvas.coach.${entry.key}.description`);
                                    entry.description2 = $scope.translate(`canvas.coach.${entry.key}.description2`);
                                    entry.event = $scope.translate(`canvas.coach.${entry.key}.event`);
                                    entry.eventText = $scope.translate(`canvas.coach.${entry.key}.eventText`);
                                }

                                return entry;
                            });

                            $scope.coachData.enabled = res.Enable;
                        } else {
                            $scope.coachData = {
                                entries: [],
                                enabled: res.Enable
                            };
                        }
                    });
            })();

            $scope.$watch('coachData', (data) => {
                if(data && !$scope.loadingCoach && $scope.deferrKeys.length) {
                    $scope.deferrKeys.map((key) => {
                        $timeout(()=>{
                            $rootScope.$emit('coach-register', key);
                        }, 100)
                    });
                }
            });

            $scope.deferrKeys = [];
            $rootScope.$on('coach-register', (evt, key) => {
                if(key && key === 'tipLooping') {
                    const coachTip = window.localStorage.getItem(`looping-coach-${$rootScope.currentAPId}`);
                    if(coachTip) {
                        return;
                    } else {
                        window.localStorage.setItem(`looping-coach-${$rootScope.currentAPId}`, 'true');
                    }
                }

                if($scope.loadingCoach && !$scope.coachData) {
                    $scope.deferrKeys.push(key);
                  return;
                }

                if (key) {
                    $scope.newEntry = true;
                    $timeout(() => {$scope.newEntry = false}, 4500);

                    if (!$scope.coachData.enabled) {
                        $scope.processEntry(key);
                    }
                    if (!$scope.entryInProgress) {
                        $scope.processEntry(key);
                    } else {
                        if($scope.coachData.entries[0].key !== key) {
                            $scope.entryQueue.push(key);
                        }
                    }
                }
            });

            $scope.processEntry = (key) => {
                let entry = {
                        key: key,
                        category: $scope.translate(`canvas.coach.${key}.category`),
                        categoryId: $scope.translate(`canvas.coach.${key}.category.id`),
                        subCategory: $scope.translate(`canvas.coach.${key}.subcategory`),
                        description: $scope.translate(`canvas.coach.${key}.description`),
                        description2: $scope.translate(`canvas.coach.${key}.description2`),
                        eventText: $scope.translate(`canvas.coach.${key}.eventText`),
                        event: $scope.translate(`canvas.coach.${key}.event`)
                    },
                    temp = [];

                let img =  $scope.translate(`canvas.coach.${key}.img`);
                if(img) {
                    entry.img =  `imgs/coaching/${img}`;
                }

                if($scope.coachData.entries.length) {
                    temp = $scope.coachData.entries.filter((item, index) => {
                        if(item.key === key) {
                            $scope.cIndex = index;
                        }

                        return item.key === key
                    });
                }

                if (temp.length) {
                    if($scope.cIndex !== 0) {
                        $scope.coachData.entries = helpers.move($scope.coachData.entries, $scope.cIndex, 0)
                    }
                } else {
                    $scope.coachData.entries.unshift(entry);
                }

                if ($scope.coachData.enabled) {
                    $scope.goSilent();
                }

                if(entry.category === 'TEMPLATE') {
                    $scope.displayCoaching();
                }

                canvasService.saveCoach($rootScope.currentAPId, $scope.coachData.entries, $scope.coachData.enabled).success((res) => {});
            };

            $scope.disableCoach = () => {
                Intercom('trackEvent', 'AP Coach - Clicked Silent Mode');
                $scope.coachData.enabled = false;
                $scope.coachingFull = false;
                canvasService.saveCoach($rootScope.currentAPId, $scope.coachData.entries, $scope.coachData.enabled).success((res) => {});
            };

            $scope.enableCoach = () => {
                $scope.coachData.enabled = true;
                canvasService.saveCoach($rootScope.currentAPId, $scope.coachData.entries, $scope.coachData.enabled).success((res) => {});
            };

            $scope.displayCoaching = () => {
                Intercom('trackEvent', 'AP Clicked Coach Icon');
                $scope.emptyData = ($scope.coachData.entries.length <= 0);
                $scope.coachingFull = true;
                $scope.coachingSilentMode = false;
                $scope.preventClosing = true;
            };

            $scope.hideCoaching = () => {
                $scope.coachingFull = false;
            };

            $scope.goSilent = () => {
                $scope.coachingSilentMode = true;
                $scope.entryInProgress = true;

                $timeout(() => {
                    $scope.coachingSilentMode = false;

                    if($scope.entryQueue.length) {
                        $scope.processEntry($scope.entryQueue.pop());
                    }

                    $scope.entryInProgress = false;
                }, 7000)
            };

            $scope.$on('closeCoaching', () => {
                if(!$scope.preventClosing) {
                    $scope.coachingFull = false;
                }
                else {
                    $scope.preventClosing = false;
                }
            });

            $scope.triggerEvent = (evt, data) => {
                $rootScope.$emit(evt, data);
            };
        }]);
})();



// WEBPACK FOOTER //
// ./app/controllers/coachingController.js